import object from 'helpers/object'


export const initialState = {
  isFetching: false,
  schoolStages: [],
}

export const setFetching = (state, payload) => (
  object.setIn(state, [ 'isFetching' ], payload)
)

export const setSchoolStages = (state, payload) => (
  object.setIn(state, [ 'schoolStages' ], payload)
)
